"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Subtitle_1 = require("../../../parts/Subtitle");
exports.default = Subtitle_1.Subtitle;
//# sourceMappingURL=Subtitle.js.map